export const removeSameValues = (obj, check) => {
  if (!check) {
    return obj;
  }
  return Object.keys(obj).reduce((result, key) => {
    if (!check[key] && obj[key] === '') {
      return result;
    }
    if (obj[key] !== check[key]) {
      result[key] = obj[key];
    }
    return result;
  }, {});
};
